import { REHYDRATE } from 'redux-persist'

import { Action } from 'src/redux/action'
import { BaseRoute } from 'src/routes/BaseRoute'
import { loadedUser, loginDone, logout } from 'src/redux/actions/user'
import { openRoute } from 'src/redux/actions/routes'
import { StateWithoutRoute } from 'src/redux/reducers'

const routes = (
  route: BaseRoute = BaseRoute(),
  action: Action,
  state: StateWithoutRoute,
): BaseRoute => {
  switch (action.type) {
    case openRoute.type:
      return { ...action.route, args: { ...route.args, ...action.args } }
    case loadedUser.type:
    case loginDone.type:
    case logout.type:
    case REHYDRATE:
      return route
    default:
      return BaseRoute.reducer(route, action, state) || BaseRoute()
  }
}

export default routes
